<template>
    <div class="form-field form-toggle" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label" v-if="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <label v-bind:style="{ width: width + 'px' }">
                    <input type="checkbox" v-model="internalValue"/>
                    <span class="on">{{ labelTrue ? labelTrue : "oui"  }}</span>
                    <span class="off">{{ labelFalse ? labelFalse : "non" }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Toggle',
        props: ['value', 'label', 'name', 'placeholder', 'index', 'labelTrue', 'labelFalse', 'callback','required'],
        data: function () {
            return {
                internalValue: '',
                width: 40
            }
        },
        created: function() {
            this.internalValue = this.property ? this.value[this.property] : this.value;
            let widthTrue = (this.labelTrue ? this.labelTrue.length * 10: 70);
            let widthFalse = (this.labelFalse ? this.labelFalse.length * 10: 70);
            this.width = widthTrue > widthFalse ? widthTrue : widthFalse;
            this.onChange = this.callback ? true : false;
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                if(typeof newVal !== "undefined"){
                    newVal = (newVal == "1" || newVal == 1) ? 1 : 0;
                }
                this.internalValue = newVal;
            },
            'internalValue'(newVal, oldVal) {
                var val = this.internalValue
                if(typeof val !== "undefined"){
                    val = (val == "1" || val == 1) ? 1 : 0;
                }
                this.$emit('input', val);
                this.$emit('event', {index:this.index, value:val});
                if( this.onChange ){
                    this.callback(val)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Toggle.vue